// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"04128a7d","180":"69ff124b","242":"85855b94","252":"ba99d9d1","290":"e94de01d","301":"a8ec19c8","306":"d9080f93","436":"a37caed9","473":"2b606600","759":"18813582","937":"aa9f480f"}[chunkId] + ".chunk.js";
};